module.exports = __webpack_public_path__ + "img/scanCodeSuccessfully.b275c94d.svg";